import {
  AddTrainingPayload,
  EditTrainingPayload,
} from "../../../../models/Training";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allTrainingKey } from "../../queries/Training/useFetchAllTraining";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function removeTraining(TRAINING_ID: number) {
  const res = await ApiClient.delete(
    `/RemoveTraining?TRAINING_ID=${TRAINING_ID}`
  );
  return res.data;
}

export const useRemoveTraining = mutationWrapper(removeTraining, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allTrainingKey);
  },
});
